import { useEffect } from 'react';

import { useSectionsNavigation } from '../../context/hooks/useSectionsNavigation';

export function RestartSectionComponent() {
  const { onGoToSection } = useSectionsNavigation();

  useEffect(() => {
    onGoToSection?.('stepOne');
  }, [onGoToSection]);

  return null;
}
